import { useEffect, useState } from 'react';
import { useEditorStore } from '@/store/editorStore';
import './StatusBar.css';

export function StatusBar() {
  const [time, setTime] = useState(() => new Date().toLocaleTimeString('pt-BR'));
  const connections = useEditorStore(s => s.connections);
  const selectedConnectionId = useEditorStore(s => s.selectedConnectionId);
  const isExecuting = useEditorStore(s => s.isExecuting);

  const selectedConn = connections.find(c => c.id === selectedConnectionId);
  const envLabel = selectedConn
    ? { Production: 'PROD', Homologation: 'HML', Development: 'DEV' }[selectedConn.environment] ?? ''
    : '';

  useEffect(() => {
    const id = setInterval(() => setTime(new Date().toLocaleTimeString('pt-BR')), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer className="statusbar">
      <div className="status-item">
        <span className="status-dot" /> Conectado <b>dev.user</b>
      </div>

      {selectedConn ? (
        <div className={`status-item ${selectedConn.environment === 'Production' ? 'prod' : ''}`}>
          {envLabel} · {selectedConn.name} / {selectedConn.database}
        </div>
      ) : (
        <div className="status-item" style={{ color: 'var(--text-muted)' }}>
          nenhuma conexão selecionada
        </div>
      )}

      <div className="status-item">Auditoria <b>ON</b></div>

      {isExecuting && (
        <div className="status-item warn">⏳ executando...</div>
      )}

      <div className="ms-auto" />
      <div className="status-item">
        {selectedConn?.engine === 'MsSql' ? 'T-SQL' : selectedConn?.engine === 'PostgreSql' ? 'PgSQL' : 'SQL'} · UTF-8
      </div>
      <div className="status-item">{time}</div>
    </footer>
  );
}
